import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=cf55dc06&"
import script from "./Pencil.vue?vue&type=script&lang=js&"
export * from "./Pencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports